import React, {useEffect, useState} from "react";
import moment from "moment";
import {connect, useSelector} from "react-redux";
import {
  GetItem,
  UpdateItem,
  CreateItem
} from "../../../../redux/actions/base";
import {AirBookingListRoute} from "../../../routesConstants";
import AirBookingForm from "../components/airBookingForm";
import {useNavigate} from "react-router";
import BlockUi from "@availity/block-ui";
import {Helmet} from "react-helmet";

const AirBookingCreatePage = props => {
  const [airBooking, setAirBooking] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()



  const airBookingTemplate = {
    paxes: [],
    segments: [],
    seller: process.env.REACT_APP_KAYAR_ID,
    issueDate: moment().startOf('day').format('DD.MM.YYYY'),
    issuedWithoutDocs: false,
    serviceComment:'',
    issuedBy: ''
  };

  useEffect(() => {
    const copied = localStorage.getItem('airbookingCopy')
    if(copied){
      console.log(JSON.parse(copied))
      setAirBooking(JSON.parse(copied))
      localStorage.removeItem('airbookingCopy')
    }else if (airBooking === null) {
      setAirBooking(airBookingTemplate);
    }
  }, [props]);
  const callback = (values, cb) => {
    setLoading(true)
    props.CreateItem(
      "/api/air/airBooking/",
      {airBooking: values, importOneS:values.importOneS, parseText: values.parseText},
      () => {
        cb();
        setLoading(false)
      },
      AirBookingListRoute
    );
  };
  return (
    <>
      <Helmet>
        <title>БСО</title>
      </Helmet>
      {airBooking ? (
        <BlockUi blocking={loading} >
          <AirBookingForm
            loading={loading}
            newForm={true}
            setter={airBooking => setAirBooking(airBooking.booking)}
            onSubmit={callback}
            data={airBooking}
          />
        </BlockUi>
      ) : null}
    </>
  );
};

export default connect(null, {GetItem, CreateItem})(AirBookingCreatePage);
